import React, { FC, ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import Svg from "../SVG/Svg";

type TProps = {
  pageTitle: string;
  shouldBackByDelta?: boolean;
  isBack?: boolean;
  navigateTo?: string;
  state?: { [index: string]: any };
  onBtnClicked?: () => void;
  showBothBtn?: boolean;
  btnCreateClass?: string;
  btnCreateText?: string;
  children?: ReactNode;
};

const PageTitle: FC<TProps> = ({
  shouldBackByDelta,
  pageTitle,
  isBack,
  navigateTo,
  state,
  onBtnClicked,
  showBothBtn,
  btnCreateClass,
  btnCreateText,
  children,
}) => {
  const btnClassName = "ms-2 btn btn-sm btn-success";
  const navigate = useNavigate();

  return (
    <div className="row mb-3 mb-md-4">
      <div className="col-12 d-flex flex-row flex-wrap align-items-center justify-content-between">
        <div className="d-flex align-items-center mb-2 ">
          {(!onBtnClicked || showBothBtn) &&
            isBack &&
            (shouldBackByDelta ? (
              <div
                onClick={() => navigate(-1)}
                className="me-4"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    navigate(-1);
                  }
                }}
              >
                <Svg icon="arrowLeft" width={26} height={26} />
              </div>
            ) : (
              <Link to={`/${navigateTo}`} state={state || {}} className="me-4">
                <Svg icon="arrowLeft" width={26} height={26} />
              </Link>
            ))}
          <h4 className="mb-0">{pageTitle}</h4>
        </div>
        <div className="d-flex flex-wrap justify-content-end row-gap-2 group ms-auto mb-2">
          {navigateTo && (!onBtnClicked || showBothBtn) && !isBack && (
            <Link to={`/${navigateTo}`} state={state || {}} className={btnClassName}>
              {btnCreateText || "Create"}
            </Link>
          )}
          {onBtnClicked && (
            <button
              type="button"
              className={` d-flex align-items-center ms-2 btn btn-sm ${
                btnCreateClass || "btn-success"
              }`}
              title={`Create ${btnCreateText}`}
              onClick={onBtnClicked}
            >
              <Svg icon="pluseLine" width={15} height={15} color="#ffffff" />
              <span className="ms-2">{btnCreateText || "Create"}</span>
            </button>
          )}
          {children && children}
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
